export default __webpack_public_path__ + "static/media/success-check.b223acde.svg";